import { namespaces, useSharedTranslation } from 'us-react-components/dist/hooks/useSharedTranslation';
import { Link } from '../../components';
import { MembershipPayment } from './MembershipPayment';

export const PaymentDisabled = (): JSX.Element => {
  const { t } = useSharedTranslation (namespaces.caregiver);

  return (
    <article className='container py-6 h-fit'>
      <div className='w-full'>
        <div className='flex flex-col md:flex-row'>
          <div className='mb-10 p-5'>
            <div>
              <h1 className='text-2xl font-bold'>{t('pages.sitter.payout.active.title')}</h1>
              <div className='mb-2'>
                {t('pages.sitter.payout.paymentDisabled')}
              </div>
              <div className='mb-8'>
                {t('pages.sitter.payout.ifQuestionsContact')}{' '}
                <Link
                  className='text-sapphire'
                  to={`mailto:${t('common.supportEmail')}`}
                  title={`${t('common.email')} ${t('pages.sitter.payout.urbanSitterSupport')}`}
                  newTab
                  external
                >
                  {t('common.supportEmail')}
                </Link>.
              </div>
              <MembershipPayment />
            </div>
          </div>
        </div>
      </div>
    </article>
  );
};
